module.exports = __webpack_public_path__ + "static/media/pic11.fd1db301.webp";